<template>
  <div>
    <vxe-grid
      ref="xTable"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :height="disabled?tableHeight - 8:tableHeight - 60"
      size="small"
      border
      resizable
      row-id="detailCode"
      :edit-config="{ trigger: 'click', mode: 'row' }"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span style="font-size: 14px; color: #606266">{{
              $l('INDEX.form_label_sample_information') || '样品信息'
            }}</span>
            <el-divider direction="vertical"></el-divider>
            <b-button
              class="mr-2"
              size="sm"
              :disabled="disabled"
              variant="outline-info"
              @click="openChooseSample()"
              >{{ $l('INDEX.tips_select_sample') || '选择样品' }}
            </b-button>
          </div>
        </slot>
      </template>
      <template v-slot:inputNumEdit="{ row }">
        <vxe-input
          v-model="row.inputNum"
          type="number"
          min="1"
          max="50"
          :disabled="disabled"
        ></vxe-input>
      </template>
      <template v-slot:opt="{ row }">
        <div v-if="!disabled">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
    <choose-sample-dialog
      :visible.sync="chooseSampleDialogVisible"
      type="checkbox"
      @confirm="addData"
    />
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      chooseSampleDialogVisible: false,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        }
      },
      type: 'checkbox',
      stockInCode: '',
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq'
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          width: 85,
          fixed: 'right',
          slots: {
            default: 'opt'
          }
        },
        {
          title: this.$l('INDEX.sample_barcode') || '样品条码',
          align: 'left',
          minWidth: '160',
          field: 'inputCode',
          showOverflow: true
        },
        {
          title: this.$l('INDEX.sample_style_no') || '样品款号',
          align: 'left',
          minWidth: '160',
          field: 'sampleStyleNo',
          showOverflow: true
        },
        {
          title: this.$l('INDEX.sample_name') || '样品名称',
          align: 'left',
          minWidth: '450',
          field: 'sampleName',
          showOverflow: true
        },
        {
          title: this.$l('INDEX.quantity') || '数量',
          align: 'left',
          minWidth: '120',
          field: 'inputNum',
          editRender: {},
          slots: {
            edit: 'inputNumEdit'
          }
        }
      ]
    }
  },
  methods: {
    // getHeight() {
    //   if (this.disabled) {
    //     this.tableHeight = window.innerHeight - 342
    //   } else {
    //     this.tableHeight = window.innerHeight - 390
    //   }
    // },

    load(val) {
      this.stockInCode = val
    },
    openChooseSample() {
      this.chooseSampleDialogVisible = true
    },
    addData(chooseData) {
      if (!chooseData) {
        return
      }
      chooseData.forEach((item) => {
        let singleRow = {
          detailCode: '',
          seqno: '',
          inputCode: '',
          sampleCode: item.sampleCode,
          sampleID: item.sampleSeqno,
          inputNum: 1,
          price: 0,
          subprice: 0,
          sampleStyleNo: item.sampleStyleNo,
          sampleName: item.sampleName
        }
        this.tableData.push(singleRow)
      })
    },
    delRow(row) {
      let index = this.$refs.xTable.getRowIndex(row)
      this.tableData.splice(index, 1)
    },
    //保存时需要
    getGoodsData() {
      return this.tableData
    }
  }
}
</script>
